exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".clients{display:block;padding:15pt;background-color:#fff}", "", {"version":3,"sources":["/home/steven/dev/Sporte/sporte2/src/components/admin/Clients/Clients.vue"],"names":[],"mappings":"AACA,SACE,cAAe,AACf,aAAc,AACd,qBAAwB,CACzB","file":"Clients.vue","sourcesContent":["\n.clients{\n  display: block;\n  padding: 15pt;\n  background-color: white;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3cddff0f","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/admin/Clients/Clients.vue
// module id = 970
// module chunks = 11